import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '../../store/userInfoStore';
import { parseNumberByPrecision } from '../../core/helpers/parseNumberByPrecision';

const ChangeAmountButtons = observer(() => {
  const { betAmount, limits, setBetAmount, precision } = userInfoStore;

  const handleAddOrMinusBetAmount = useCallback(
    (action) => {
      let changedBetAmount;
      if (action === '-') {
        changedBetAmount = +betAmount - (limits?.minBet || 0);
        changedBetAmount = changedBetAmount > limits?.minBet ? changedBetAmount : limits?.minBet;
      } else {
        changedBetAmount = +betAmount + (limits?.minBet || 0);
        if (limits.maxBet) {
          changedBetAmount = changedBetAmount < limits.maxBet ? changedBetAmount : limits.maxBet;
        }
      }
      setBetAmount(parseNumberByPrecision(1, changedBetAmount, precision));
    },
    [betAmount, limits, precision, setBetAmount]
  );

  return (
    <div className='numpad-item numpad-action-wrapper'>
      <div className='numpad-action-block'>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          className={`numpad-modifier left ${+betAmount === limits?.minBet ? 'disabled' : ''}`}
          onClick={() => handleAddOrMinusBetAmount('-')}
        >
          <i className='icon-rounded-minus' />
        </button>
        <p className='money-count'>{betAmount}</p>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          className={`numpad-modifier right ${+betAmount === limits?.maxBet ? 'disabled' : ''}`}
          onClick={() => handleAddOrMinusBetAmount('+')}
        >
          <i className='icon-rounded-plus' />
        </button>
      </div>
    </div>
  );
});
export default ChangeAmountButtons;
